import CatalogIconImageWhite from "./../../icons/default/catalogWhite.png";

import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const CatalogWhiteIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return <img style={style} className={className} src={CatalogIconImageWhite} />;
};
